import api from "api"
import client from "dataCmsClient"

export async function loadMethodology(store) {
  const methodolgy = await api.fetchText(
    `auth/disclosures/${store.meta.appId}/methodology`,
    "",
    "get",
    {}
  )
  await store.update(state => {
    state.methodology = methodolgy
  })
}

export async function loadAgreements(store) {
  const agreements = await api.fetchJson(
    `auth/new-user-agreements/${store.meta.appId}`,
    { channel_id: store.meta.channelId },
    "GET",
    {}
  )
  await store.update(state => {
    state.agreements = agreements
  })
}

export async function loadNewAgreements(store) {
  const agreements = await api.get("user/agreements", undefined, {})
  const newAgreements = agreements.filter(
    ({ is_action_completed, action_required }) =>
      is_action_completed === false &&
      (action_required === "accept" || action_required === "sign")
  )
  const nonExplicitAgreements = agreements.filter(
    ({ is_action_completed, action_required }) =>
      is_action_completed === false &&
      (action_required === "none" || action_required === "receive")
  )
  await store.update(state => {
    state.newAgreements = newAgreements
  })
  await store.update(state => {
    state.nonExplicitAgreements = nonExplicitAgreements
  })
}

export async function acceptNonExplicitAgreements(store, ids) {
  await api.post("user/agreements", undefined, {
    agreement_ids: ids
  })
}

export async function acceptAgreement(store, id) {
  const agreements = await api.post("user/agreements", undefined, {
    agreement_ids: [id]
  })
  const newAgreements =
    agreements.filter(
      ({ is_action_completed, action_required }) =>
        is_action_completed === false &&
        (action_required === "accept" || action_required === "sign")
    ) || []
  await store.update(state => {
    state.newAgreements = newAgreements
  })
}

export async function loadAgreementContent(store, id) {
  const agreementText = await api.fetchJson(
    `auth/agreements/${id}/content`,
    {},
    "GET",
    {}
  )
  await store.update(state => {
    state.agreementTexts[id] = agreementText
  })
}

export async function loadTermsAndConditions(store) {
  const terms = await api.fetchText(
    `auth/disclosures/${store.meta.appId}/terms-of-use`,
    { channel_id: store.meta.channelId },
    "get",
    {}
  )
  await store.update(state => {
    state.termsAndConditions = terms
  })
}

export async function setChannelId(store, channelId) {
  store.meta.channelId = channelId
}

export async function loadFaq(store, faqId) {
  let content
  let title = ""
  try {
    const query = `query {
      faq(filter: { slug: { eq: "${faqId}" } }) {
        title
        content
      }
    }`
    const data = await client.request(query)
    content = data.faq.content
    title = data.faq.title
  } catch (error) {
    content = "We're sorry, but his content appears to be missing."
  }
  await store.update(state => {
    state.faqs[faqId] = { content, title }
  })
}

export async function loadHouseholdOffers(store, household_id) {
  const savings = await api.fetchJson(
    "offers/evenfi/savings",
    {
      state:
        store.getState("households", household_id).primary_state_of_residence ||
        "MA"
    },
    "GET",
    {}
  )
  await store.update(state => {
    state.householdOffers[household_id] = {
      savings: savings
    }
  })
}

export async function loadContextual(store, req) {
  const query = `query {
    contextual(filter: {context: {eq: "${req}" }}) {
      label,
      description,
      faqs {
        title,
        slug
      },
    }
  }`
  try {
    const data = await client.request(query)
    const { contextual } = data
    contextual.faqs.forEach(faq => {
      faq.id = faq.slug
      faq.label = faq.title
      delete faq.slug
      delete faq.title
    })
    await store.update(state => {
      state.contextuals[req] = contextual
    })
  } catch (error) {
    await store.update(state => {
      state.contextuals[req] = {
        label: "",
        description: "",
        faq: {
          id: "",
          label: ""
        }
      }
    })
  }
}
